import { Form, Formik } from 'formik';
import { Props, Values } from './TeamForm.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';
import { PermissionForm } from './PermissionForm';
import { useTranslation } from '../../context/translationContext';

export const TeamForm = ({ onSubmit, initialValues, membershipId, onBack }: Props) => {
  const { t } = useTranslation();
  const _initialValues: Values = {
    name: '',
    description: '',
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Team name is required.'),
  });
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="my-4">
            <FormField
              id="name"
              name="name"
              label={t('page.team.input-name')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="description"
              name="description"
              label={t('page.team.input-description')}
            />
          </div>

          {membershipId && (
            <div className="my-4">
              <PermissionForm companyTeamMemberId={membershipId} />
            </div>
          )}
          <div className="flex float-left">
            <Button title={t('general.back')} color="gray" className="mr-3" onClick={onBack} />
            <Button title={t('general.save')} color="green" type="submit" showLoading />
          </div>
        </Form>
      )}
    </Formik>
  );
};
